<script>
  import { digitalLoadMethods, digitalLoadComputed, layoutMethods, exportMethods, erpUserRolesMethods } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import { required } from "vuelidate/lib/validators";
  import { getModuleAccess, showAccessRestrictedModal } from '@/router/helper.js'
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Moment from 'moment';
  import 'moment-timezone';
  import { extendMoment } from 'moment-range';

  const moment = extendMoment(Moment);

  /**
   * E-Load Topups SKU formcomponent
   */
  export default {
    page: {
      title: "E-Load SKU Form",
    },
    data() {
      return {
        title: "E-Load SKU",
        tempRebate: 0,
        topupsItem: {
            topupId: null,
            topupName: "",
            topupAmount: "",
            topupRebate: "4",
            backupRebate: "4",
            skuStatus:1,
            scheduleDetails: [],
        },
        formExitChecker: {
            topupId: null,
            topupName: "",
            topupAmount: "",
            topupRebate: "4",
            skuStatus:1
        },
        skuId: 0,
        submitted: false,
        rebateEditable:false,
        running_campaigns: 0,
        orgSkuStatus: false,
        eloadTopupsModule: {
          access: {
            create: true,
            update: true,
          }
        },

        rebatesTableFields: [
        {
          key: "action",
          sortable: false,
          tdClass: 'align-middle',
          thStyle: ''
        },
        {
          key: "rebate",
          label: "Topup Rebate",
          sortable: false,
          tdClass: 'align-middle',
        },
        {
          key: "startDate",
          sortable: false,
          tdClass: 'align-middle',
        },
        {
          key: "endDate",
          sortable: false,
          tdClass: 'align-middle',
        },
        {
          key: "status",
          sortable: false,
          tdClass: 'align-middle',
          thStyle: ''
        },
      ],
      showRebateModal: false,
      rebateStatus: false,
      rebateRate: null,
      rebateStart: null,
      rebateEnd: null,
      rebateApprovalStatus: 'pending',
      rebateEmailRequester: '',
      rebateEmailApprover: '',
      rebateApproveDate: '',
      rebateApprovalToken: '',
      rebateApprovalExpireAt: '',
      rebateSubmitted: false,
      rebateAction: '',
      rebateDateCreated: null,
      updateRebate: false,
      rebateStartDateConfig: {
        minDate: "",
        maxDate: ""
      },
      rebateEndDateConfig: {
        minDate: "",
        maxDate: ""
      },
      logsCurrentPage: 1,
      logsPerPage: 10,
      logsPageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      logsSort: 'id',
      logsSortBy: "value",
      logsSortDesc: false,
      logsDateRange: null,
      logsOrderDesc: true,
      rangeOptions: {
          mode: "range",
      },
      isSearching: false,
      rebateIndex: null,
      dateRangeOverlap: false,
      dateStartIsOutdated: false,
      showRebateLogsModal: false,
      rebateLogs: [],
      rebatesLogsFields: [
          {
            key: "action",
            label: "Action",
            sortable: false,
            tdClass: 'align-middle',
            thStyle: ''
          },
          {
            key: "skuName",
            label: "SKU Name",
            sortable: false,
            tdClass: 'align-middle',
            thStyle: ''
          },
          {
            key: "rebate",
            label: "Schedule Rebate",
            sortable: true,
            tdClass: 'align-middle',
          },
          {
            key: "startDate",
            sortable: true,
            tdClass: 'align-middle',
          },
          {
            key: "endDate",
            sortable: true,
            tdClass: 'align-middle',
          },
          {
            key: "isActive",
            label: "Status",
            sortable: false,
            tdClass: 'align-middle',
          },
          {
            key: "dateCreated",
            sortable: true,
            tdClass: 'align-middle',
          },
          {
            key: "createdBy",
            sortable: true,
            tdClass: 'align-middle',
            thStyle: ''
          },
        ],
      };
    },
 
    validations:{
      topupsItem:{
        topupName: {required},
        topupAmount: {required},
        topupRebate: {required},
        backupRebate: {required},
      },
      rebateRate: {required},
      rebateStart: {required},
      rebateEnd: {required}
    },
    components: {
      flatPickr
    },
    computed: {
      ...digitalLoadComputed
    },
    async mounted() {
      this.skuId = this.$route.params.id;
      this.changeTitle({title: (this.skuId > 0 ? "Edit" : "Add") +' E-Load SKU Name'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Digital Load', to: { name: 'Digital Load'} },
          { text: 'E-Load Topups', to: { name: 'E-Load Topups'} },
          { text: 'E-Load SKU', to: { name: 'E-Load sku'} }
        ]
      });
      if(this.skuId > 0){
        this.getInfo();
      }else{
        this.getDefaultRebate();
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Topups')
      .then((access) => this.eloadTopupsModule.access = access);

      console.log(JSON.stringify(this.eloadTopupsModule));
      let self = this;
      if(this.$route.params.token)
      {
        // console.log("Show action form: ", this.$route.params.token);
        await this.actionTopups({
            action: "verify-action-schedule-rebate",
            body:{skuId: this.skuId, token: this.$route.params.token}
          })
          .then(async (_response) => {
            console.log("verify-action-schedule-rebate Result: ", _response);
            if(_response.status == 'ok')
            {
              await Swal.fire({
                title: "Request Approval Form for Topup - Schedule Rebate",
                html: `Do you wish to approve this Topup Schedule Rebate?`,
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Deny",
                confirmButtonColor: "#c4297c",
                cancelButtonColor: "#804997",
                confirmButtonText: "Approve",
              }).then(async(result) => {
                let action = result.isConfirmed ? 'approved' : 'denied';
                await this.actionTopups({
                    action: "action-schedule-rebate",
                    body:{skuId : this.skuId, action: action, token: this.$route.params.token}
                  })
                  .then(async (response) => {
                    console.log("Action Schedule Rebate Result: ", response);
                    await Swal.fire(response.status == 'ok' ? "Successfull!" : "Failed!", 
                      response.message,
                      response.status == 'ok' ? "success" : "error"
                    
                    ).then(() => {
                      
                      self.$router.push(self.$route.query.redirectFrom || { name: "E-Load sku", id: self.skuId});
                      if(self.skuId > 0){
                        self.getInfo();
                      }else{
                        self.getDefaultRebate();
                      }
                    });
                  })
                  .catch(function(error) {
                    // this.$alertify.error(error);
                    console.log(error);
                });
              });
            }
            else {
              await Swal.fire("Invalid!", 
                _response.message,
                "error"
              ).then(() => {
                self.$router.push(self.$route.query.redirectFrom || { name: "E-Load sku", id: self.skuId});
              });
            }
          })
          .catch(async function(error) {
            await Swal.fire("Failed!", 
              error,
              "error"
            ).then(() => {
              self.$router.push(self.$route.query.redirectFrom || { name: "E-Load sku", id: self.skuId});
            });
            console.log(error);
        });
      }

    },
    watch: {
      rebateStart(newVal) {
        this.rebateEndDateConfig.minDate = newVal;
        this.dateRangeOverlap = false;
      },
      rebateEnd(newVal) {
        this.rebateStartDateConfig.maxDate = newVal;
        this.dateRangeOverlap = false;
      }
    },
    methods: {
      ...layoutMethods,
      ...digitalLoadMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      onInputBackupRebate()
      {
        let hasActiveSchedule = false;
          if(this.topupsItem.scheduleDetails != null && this.topupsItem.scheduleDetails.length > 0)
          {
            for (let index = 0; index < this.topupsItem.scheduleDetails.length; index++) 
            {
              let scheduled = this.topupsItem.scheduleDetails[index];
              if(scheduled.isActive)
              {
                hasActiveSchedule = true;
              }
            }
          }

          if(!hasActiveSchedule) this.topupsItem.topupRebate = this.topupsItem.backupRebate;
      },
      createEloadTopups(){
        this.submitted = true
        this.$v.$touch();
        if(this.topupsItem.scheduleDetails != null && this.topupsItem.scheduleDetails.length > 0) this.topupsItem.scheduleDetails = JSON.stringify(this.topupsItem.scheduleDetails);
        if (!this.$v.topupsItem.$invalid){
          this.actionTopups({
            action: "create",
            body:{...this.topupsItem}
          })
          .then(() => {
            // this.$alertify.success((this.skuId > 0 ? "Updated" : "Added") +" Successfully");
            Swal.fire(
              (this.skuId > 0 ? "Updated" : "Added") +" Successful!",
              `${this.topupsItem.topupName} has been created.`,
              "success"
            );
            this.formExitChecker = this.topupsItem
            this.$router.push(
              this.$route.query.redirectFrom || {
                name: "E-Load Topups",
              }
            );
          })
          .catch(function(error) {
            this.$alertify.error(error);
            console.log(error);
          });
        }
      },
      getInfo(){
        this.actionTopups({
          action: "get-info",
          body:{
            topupId: this.skuId
          }
        })
        .then((res) => {
          // console.log(res);
          this.topupsItem = res.message
          this.topupsItem.scheduleDetails = this.topupsItem.scheduleDetails != null && this.topupsItem.scheduleDetails.length > 0 ? JSON.parse(this.topupsItem.scheduleDetails) : [];
          this.formExitChecker = res.message
          this.running_campaigns = res.message.campaigns? res.message.campaigns: 0 
          this.orgSkuStatus = res.message.skuStatus? res.message.skuStatus: false
        })
      },
      handleSubmit(){
        if(this.skuId > 0){
          this.updateEloadTopups();
        }else{
          this.createEloadTopups();
        }
      },
      updateEloadTopups() {
        // alert("hey");
        this.submitted = true
        this.$v.$touch();
        console.log(">>> campaigns:",this.running_campaigns);
        // console.log(">>> checker:",JSON.stringify(this.formExitChecker));
        // console.log(">>> item:",JSON.stringify(this.topupsItem));
        if (!this.$v.topupsItem.$invalid){
          if(this.running_campaigns > 0 && this.orgSkuStatus != (this.topupsItem.skuStatus==1?true:false) && this.orgSkuStatus){
            Swal.fire({
              title: "Disable SKU Status",
              text: `On going campaign will be automatically set to Onhold and Disabled.`,
              icon: "question",
              showCancelButton: true,
              cancelButtonText: "Cancel",
              confirmButtonColor: "#c4297c",
              cancelButtonColor: "#804997",
              confirmButtonText: "Confirm",
            }).then((result) => {
              if (result.value) {
                // alert("update status");
                this.actionTopups({
                  action: "update",
                  body:{
                    id : this.topupsItem.topupId.toString(),
                    topupAmount : this.topupsItem.topupAmount.toString(),
                    topupName: this.topupsItem.topupName.toString(),
                    topupRebate: this.topupsItem.topupRebate.toString(),
                    backupRebate: this.topupsItem.backupRebate.toString(),
                    skuStatus: this.topupsItem.skuStatus,
                    campaigns: this.running_campaigns
                  }
                })
                .then((response) => {
                  console.log("update status:",response);
                  // this.$alertify.success((this.skuId > 0 ? "Updated" : "Added") +" Successfully");
                  Swal.fire(
                    (this.skuId > 0 ? "Updated" : "Added") +" Successful!",
                    `${this.topupsItem.topupName} has been updated.`,
                    "success"
                  );
                  this.$router.push(
                    this.$route.query.redirectFrom || {
                      name: "E-Load Topups",
                    }
                  );
                })
                .catch(function(error) {
                  console.log(error);
                  this.$alertify.error(error);
                  return;
                });
              }else{//return to its previous status when no is selected
                this.topupsItem.skuStatus = !this.topupsItem.skuStatus
              }
            });
          }else{
            this.actionTopups({
              action: "update",
              body:{
                id : this.topupsItem.topupId.toString(),
                topupAmount : this.topupsItem.topupAmount.toString(),
                topupName: this.topupsItem.topupName.toString(),
                topupRebate: this.topupsItem.topupRebate.toString(),
                backupRebate: this.topupsItem.backupRebate.toString(),
                skuStatus: this.topupsItem.skuStatus,
                campaigns: this.running_campaigns
              }
            })
            .then((response) => {
              console.log("update status:",response);
              // this.$alertify.success((this.skuId > 0 ? "Updated" : "Added") +" Successfully");
              Swal.fire(
                (this.skuId > 0 ? "Updated" : "Added") +" Successful!",
                `${this.topupsItem.topupName} has been updated.`,
                "success"
              );
              this.$router.push(
                this.$route.query.redirectFrom || {
                  name: "E-Load Topups",
                }
              );
            })
            .catch(function(error) {
              console.log(error);
              this.$alertify.error(error);
              return;
            });
          }
        }//*/
      },
      addDiscount() {
      // restrict if user has no update access
        if (this.skuId > 0) {
          if (!this.eloadTopupsModule.access.update) {
            showAccessRestrictedModal();
            return;
          }
        }
        this.rebateStatus = false;
        this.rebateAction = 'add';
        this.showRebateModal = true;
      },
      editScheduleRebate(row) {
        // restrict if user has no update access
        if (this.skuId > 0) {
          if (!this.eloadTopupsModule.access.update) {
            showAccessRestrictedModal();
            return;
          }
        }
        console.log("edit Row: ", row.index);

        this.rebateAction = 'edit';
        this.rebateIndex = row.index;
        this.rebateRate = row.item.rebate;
        this.rebateStart = row.item.startDate;
        this.rebateEnd = row.item.endDate;
        this.rebateStatus = row.item.isActive;
        this.rebateDateCreated = row.item.dateCreated;
        this.showRebateModal = true;
    },
    async deleteScheduleRebate(row) {
        // restrict if user has no update access
        if (this.skuId > 0) {
          if (!this.eloadTopupsModule.access.update) {
            showAccessRestrictedModal();
            return;
          }
        }
        console.log("row: ", row.index);

        Swal.fire({
          title: 'Are you sure?',
          text: `Do you really want to delete the scheduled rebate? This process cannot be undone.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '##804997',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(async (result) => {
          if (result.isConfirmed) {

            let scheduleDetails = {
              rebate: row.item.rebate,
              startDate: row.item.startDate,
              endDate: row.item.endDate,
              isActive: row.item.isActive,
              dateCreated: row.item.dateCreated,
              dateModified: row.item.dateModified
            }

            
            this.topupsItem.scheduleDetails.splice(row.index , 1);
      
            if (this.skuId > 0) {
              await this.actionTopups({
                action: 'update-schedule-rebate',
                body: {
                  skuId: this.skuId.toString(),
                  skuAmount: this.topupsItem.topupAmount,
                  skuName: this.topupsItem.topupName,
                  rebateAction: 'delete',
                  scheduleDetails: JSON.stringify(this.topupsItem.scheduleDetails),
                  singleDetails: JSON.stringify(scheduleDetails)
                }
              })
              .then(() => {
                Swal.fire(
                  "Delete Successful",
                  "Schedule Rebate has been deleted",
                  "success"
                ).then(() => {
                  this.rebateSubmitted = false;
                  this.getInfo();
                });
              })
              .catch(() => {
                Swal.fire(
                  "Delete Failed",
                  "Please try again later",
                  "error"
                )
              })
            } 

          }
        })
        return;
      },
      disableEditSchedule(row)
      {
        // eslint-disable-next-line no-unused-vars
        let disabled = row.item.isActive;
        const timeZone = 'Asia/Manila';
        const startDate = moment.tz(row.item.startDate, timeZone);
        const endDate = moment.tz(row.item.endDate, timeZone).add(1, 'd');
        const isBetween = moment.tz(timeZone).isBetween(startDate, endDate, null, '[]');

        if(isBetween) disabled = true;
        // if(row.item.approvalStatus == 'pending' )
        return true;
      },
      async submitRebate() {
        this.rebateSubmitted = true;
        this.$v.$touch();
        
        if (this.$v.rebateRate.$invalid || this.$v.rebateStart.$invalid || this.$v.rebateEnd.$invalid) {
          return;
        }

        if(this.rebateAction == 'edit')
        {
          if(this.topupsItem.scheduleDetails[this.rebateIndex].startDate < moment().format('YYYY-MM-DD'))
          {
            this.dateStartIsOutdated = true;
            return;
          }
        }
        else {
          if(this.rebateStart < moment().format('YYYY-MM-DD'))
          {
            this.dateStartIsOutdated =true;
            return;
          }
        }
        
        this.dateStartIsOutdated = false;

        if(this.topupsItem.scheduleDetails != null && this.topupsItem.scheduleDetails.length > 0)
        {
          for (let index = 0; index < this.topupsItem.scheduleDetails.length; index++) 
          {
            let scheduled = this.topupsItem.scheduleDetails[index];
            if (this.rebateIndex != index && !this.dateRangeOverlap && scheduled.approvalStatus != 'denied') 
            {
              
              let existingDateRange = moment.range(scheduled.startDate, scheduled.endDate);
              let submittedDateRange = moment.range(this.rebateStart, this.rebateEnd);
              
              if (submittedDateRange.overlaps(existingDateRange) || moment(this.rebateStart).isSame(moment(scheduled.startDate), 'day') || moment(this.rebateEnd).isSame(moment(scheduled.startDate), 'day')) {
                this.dateRangeOverlap = true;
              }
            }
          }
        }

        if(this.dateRangeOverlap) return;
        
        let scheduleDetails = {
          rebate: this.rebateRate,
          startDate: this.rebateStart,
          endDate: this.rebateEnd,
          isActive: this.rebateStatus,
          dateCreated: this.rebateAction == 'add' ? moment.tz('Asia/Manila').format("YYYY-MM-DD hh:mm:ss A") : this.rebateDateCreated,
          dateModified: this.rebateAction == 'edit' ? moment.tz('Asia/Manila').format("YYYY-MM-DD hh:mm:ss A") : '',
          approved: this.rebateApproved,
          approvalStatus: this.rebateApprovalStatus,
          emailRequester: this.rebateEmailRequester,
          emailApprover: this.rebateEmailApprover,
          approvalToken: this.rebateApprovalToken,
          approvalExpireAt: this.rebateApprovalExpireAt
        }
        
        if (this.rebateAction == 'add') {
          this.topupsItem.scheduleDetails.push(scheduleDetails);
        } else if (this.rebateAction == 'edit') {
          this.topupsItem.scheduleDetails[this.rebateIndex] = scheduleDetails;
          this.$refs.rebateTable.refresh();
        }        
        // update the schedule rebate
        if (this.skuId > 0) {
          await this.actionTopups({
            action: 'update-schedule-rebate',
            body: {
              skuId: this.skuId.toString(),
              skuAmount: this.topupsItem.topupAmount,
              skuName: this.topupsItem.topupName,
              rebateAction: this.rebateAction,
              singleDetails: JSON.stringify(scheduleDetails),
              scheduleDetails: JSON.stringify(this.topupsItem.scheduleDetails),
              
            }
          })
          .then(() => {
            this.closeShowRebateModal();
            Swal.fire(
              `${this.rebateAction == 'add' ? 'Add' : 'Update'} Successful`,
              `Schedule Rebate has been ${this.rebateAction == 'add' ? 'added' : 'updated'}`,
              "success"
            ).then(() => {
              this.rebateSubmitted = false;
              this.getInfo();
            });
          })
          .catch(() => {
            Swal.fire(
              `${this.rebateAction == 'add' ? 'Add' : 'Update'} Failed`,
              "Please try again later",
              "error"
            )
          })
        } else {
          this.closeShowRebateModal();
        }
      },
      closeShowRebateModal() {
        this.showRebateModal = false;
        this.rebateSubmitted = false;
        this.rebateRate = null;
        this.rebateStart = null;
        this.rebateEnd = null;
        this.rebateAction = '';
        this.rebateDateCreated = null;
        this.dateRangeOverlap = false;
      },
      getCurrentRebateRunningByRow(row) {
        if(!row.item.isActive) return false;
        let existingDateRange = [moment(row.item.startDate), moment(row.item.endDate).add(1, 'day')];
        let currentDate = [moment(), moment()];

        let range1 = moment.range(existingDateRange);
        let range2 = moment.range(currentDate);

        // check if date range overlaps
        if (range2.overlaps(range1)) {
          return true;
        }
        return false;
        
      },
      getCurrentRebateRunning() {
        if(this.topupsItem.scheduleDetails != null && this.topupsItem.scheduleDetails.length > 0)
        {
          for (let scheduled of this.topupsItem.scheduleDetails) {
              if(!scheduled.isActive) continue;
              let existingDateRange = [moment(scheduled.startDate), moment(scheduled.endDate).add(1, 'day')];
              let currentDate = [moment(), moment()];
      
              let range1 = moment.range(existingDateRange);
              let range2 = moment.range(currentDate);
      
              // check if date range overlaps
              if (range2.overlaps(range1)) {
                return `${scheduled.rebate}% from ${moment(scheduled.startDate).format('YYYY-MM-DD')} to ${moment(scheduled.endDate).format('YYYY-MM-DD')} is on schedule!`;
              }
          }
        }
        return false;
      },
      rebateIsDenied(row)
      {
        console.log("rebateIsDenied: ", row);
        return row.item.approveStatus == "denied";
        
      },
      returnRebateStatus(row)
      {
        //  console.log("row.item.rebateApprovalStatus: ", JSON.stringify(row.item));
        if(row.item.approvalStatus.length > 0 && row.item.approvalStatus == "denied") 
        {
          return 1;
        }
        if(!(row.item.endDate >= moment().format('YYYY-MM-DD'))) 
        {
          return 2;
        }
        return 0;
      },
      getRebateStatusLabel(row)
      {
        if(row.item.approvalStatus.length > 0 &&row.item.approvalStatus == "denied") 
        {
          return 'Denied Request';
        }
        else if(!(row.item.endDate >= moment().format('YYYY-MM-DD'))) 
        {
          console.log("Ended");
          return 'Schedule has Ended';
        }
        return '';
      },
      rebateIsNotOver(row) {
        // this will check if the rebate schedule is over, if yes we will hide the toggle button
        return row.item.endDate >= moment().format('YYYY-MM-DD') ? true : false;
      },
      leaveform(next){
          if(JSON.stringify(this.topupsItem) == JSON.stringify(this.formExitChecker)){
            next();
            return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{
                  return;
              }
          })
      },
      enableRebate(){
        this.rebateEditable = !this.rebateEditable 
      },
      getDefaultRebate(){
        this.actionTopups({
          action: "get-default-rebate",
          body:{}
        })
        .then((res) => {
          // console.log(res);
          this.topupsItem.topupRebate = res.message
          this.topupsItem.backupRebate = res.message
          this.formExitChecker.topupRebate = res.message
        })
      },
      async onClickScheduleRebateStatus(row)
      {
        // if(this.skuId == 0) return;

        if(row.item.approvalStatus == 'pending' || row.item.approvalStatus == 'denied') 
        {
          
          console.log("row.item.approvalStatus: ", row.item.approvalStatus);
          if(row.item.approvalStatus == 'pending')
          {
            if(moment.tz('Asia/Manila').isAfter(moment.tz(row.item.approvalExpireAt, 'MMMM DD, YYYY', 'Asia/Manila')))
            {
              await Swal.fire({
                title: "Activating/Deactivating Schedule Rebate",
                html: `This schedule request has <span style="color:red; font-weight: 800;">expired</span>. Please request another for approval if you wish to push this schedule.`,
                icon: "warning",
                showCancelButton: false,
                cancelButtonText: "Cancel",
                confirmButtonColor: "#c4297c",
                cancelButtonColor: "#804997",
                confirmButtonText: "Okay"}).then(result => {
                    console.log(result);
                    row.item.isActive = !row.item.isActive;
                });
              return;
            }
            await Swal.fire({
              title: "Activating/Deactivating Schedule Rebate",
              html: `This schedule is currently <span style="color:orange; font-weight: 800;">${row.item.approvalStatus}</span> therefore you cannot change the status.`,
              icon: "warning",
              showCancelButton: false,
              cancelButtonText: "Cancel",
              confirmButtonColor: "#c4297c",
              cancelButtonColor: "#804997",
              confirmButtonText: "Okay"}).then(result => {
                  console.log(result);
                  row.item.isActive = !row.item.isActive;
              });
          }
          else if(row.item.approvalStatus == 'denied')
          {
            await Swal.fire({
              title: "Activating/Deactivating Schedule Rebate",
              html: `This schedule has been <span style="color:red; font-weight: 800;">${row.item.approvalStatus}</span> by ${row.item.emailApprover} you can't activate this.`,
              icon: "warning",
              showCancelButton: false,
              cancelButtonText: "Cancel",
              confirmButtonColor: "#c4297c",
              cancelButtonColor: "#804997",
              confirmButtonText: "Okay"}).then(result => {
                  console.log(result);
                  row.item.isActive = !row.item.isActive;
              });
            
          }
          return;
        }
        

        await Swal.fire({
              title: "Activating/Deactivating Schedule Rebate",
              html: `You are about to ${!row.item.isActive ? '<span style="color:green; font-weight: 800;">Activate</span>' : '<span style="color:red; font-weight: 800;">De-activate</span>'} this <span style="color: #F7CC53; font-weight: 500;">${row.item.rebate}% from ${row.item.startDate} to ${row.item.endDate}</span> schedule rebate.`,
              icon: "warning",
              showCancelButton: true,
              cancelButtonText: "Cancel",
              confirmButtonColor: "#c4297c",
              cancelButtonColor: "#804997",
              confirmButtonText: "Confirm",
            }).then(async(result) => {
              if(result.isConfirmed)
              {
                if (this.skuId > 0) {

                  let scheduleDetails = {
                    rebate: row.item.rebate,
                    startDate: row.item.startDate,
                    endDate: row.item.endDate,
                    isActive: row.item.isActive,
                    dateCreated: row.item.dateCreated,
                    dateModified: moment.tz('Asia/Manila').format("YYYY-MM-DD hh:mm:ss A")
                  }
                  await this.actionTopups({
                    action: 'update-schedule-rebate',
                    body: {
                      skuId: this.skuId.toString(),
                      skuAmount: this.topupsItem.topupAmount,
                      skuName: this.topupsItem.topupName,
                      rebateAction: 'edit',
                      singleDetails: JSON.stringify(scheduleDetails),
                      scheduleDetails: JSON.stringify(this.topupsItem.scheduleDetails),
                    }
                  })
                  .then(() => {
                    Swal.fire({
                      title: "Activating/Deactivating Schedule Rebate",
                      html:`Schedule Rebate <span style="color: #F7CC53; font-weight: 500;">${row.item.rebate}% from ${row.item.startDate} to ${row.item.endDate}</span> has been ${row.item.isActive ? '<span style="color:green; font-weight: 800;">Activated</span>' : '<span style="color:red; font-weight: 800;">De-activated</span>'}.`,
                      icon:"success"
                    }).then(() => {
                      this.getInfo();
                    });
                  })
                  .catch(() => {
                    Swal.fire(
                      `${this.rebateAction == 'add' ? 'Add' : 'Update'} Failed`,
                      "Please try again later",
                      "error"
                    )
                    this.getInfo();
                  })
                }
              }
              else {
                row.item.isActive = !row.item.isActive;
              }
            });
      },
      async getRebateLogs() {
        this.logsCurrentPage = this.isSearching ? 1 : this.logsCurrentPage;
        
        let params = {
          body: {
            skuId: this.skuId.toString(),
            sort: 'DESC',
            page: this.logsCurrentPage,
            rows: this.logsPerPage,
            orderDesc: this.logsOrderDesc,
            dateRange: this.logsDateRange
          }
        }

        await this.getScheduleRebateLogsList(params)
          .then(() => {
            console.log(this.scheduleRebateLogsList);
            this.rebateLogs = JSON.parse(JSON.stringify(this.scheduleRebateLogsList));
            this.rebateLogs = this.rebateLogs.map(log => {
              log.details = {action: log.action,...JSON.parse(log.details)};
              return log;
            })
            this.showRebateLogsModal = true;
        })
    },
    closeLogsModal() {
      this.showRebateLogsModal = false;
      this.logsDateRange = null;
      // this.filter.status = null;
      this.logsCurrentPage = 1;
      this.logsPerPage = 10;
      this.logsSort = 'id';
      this.logsSortBy = 'value';
      this.logsSortDesc = false;
      this.logsOrderDesc = true;
    },
    tableSorting(action) {
      var column = "";
      switch(action.sortBy) {
          case 'rate' :
              column = 'rate';
              break;
          case 'startDate' :
              column = 'startDate';
              break;
          case 'endDate' :
              column = 'endDate';
              break;
          case 'dateCreated' :
              column = 'createdAt';
              break;
          case 'createdBy' :
              column = 'actor';
              break;
      }
      this.logsSort = column;
      this.logsOrderDesc = action.sortDesc;
      this.getRebateLogs();
    },
    async onExport() {
      let params = {
        module: 'eload_skutopup_schedule_rebate_logs',
        email: JSON.parse(localStorage.getItem('userData')).email,
        skuId: this.skuId.toString(),
        sort: this.logsSort,
        orderDesc: this.logsOrderDesc,
        dateRange: this.logsDateRange
      };

      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
    },
    beforeRouteLeave(to, from, next) {
        console.log("><><><><> HEY",JSON.stringify(this.topupsItem),JSON.stringify(this.formExitChecker));
        this.leaveform(next);
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <form class="px-4 py-3" @submit.prevent="handleSubmit()">
              <div class="row">
                <label v-if="(skuId <= 0 || isNaN(skuId)) && !eloadTopupsModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a SKU.</label>
                <label v-else-if="skuId > 0 && !eloadTopupsModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a SKU.</label>
                <div class="row mb-4">
                  <div class="col-12">
                      <div class="form-check form-switch">
                        <label class="form-check-label" for="flexSwitchCheckDefault">Enable</label>
                        <input
                          class="form-check-input"
                          v-model="topupsItem.skuStatus"
                          type="checkbox"
                          id="flexSwitchCheckDefault"
                        />
                      </div>
                    </div>
                </div>
                <div class="mb-3 col-sm-12">
                  <label class="form-label"
                    >Topups Name<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="topupsItem.topupName"
                    placeholder="Enter Topup Name"
                    :class="{
                      'is-invalid':
                        submitted && $v.topupsItem.topupName.$error,
                    }"
                
                  />
                </div>
              </div>
              <div class="row">
                <div class="mb-3 col-sm-5">
                  <label class="form-label"
                    >Default Rebate<span style="color: red">*</span></label
                  >
                  <b-input-group>
                    <b-form-input
                    type="text"
                      class="form-control"
                      v-model="topupsItem.backupRebate"
                      @input="onInputBackupRebate()"
                      placeholder="0%"
                      :class="{
                        'is-invalid':
                          submitted && $v.topupsItem.topupRebate.$error,
                      }"
                      :disabled="!rebateEditable"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        variant="light"
                        type="button"
                        class="rounded-0 rounded-end px-2" 
                        style="border: 1px #ccc solid;"
                        @click="enableRebate()"
                      >
                        <i class="bx bx-edit bx-fw"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
                <div class="mb-3 col-sm-7">
                  <label class="form-label"
                    >Amount<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="topupsItem.topupAmount"
                    placeholder="0.00"
                    :class="{
                      'is-invalid':
                        submitted && $v.topupsItem.topupAmount.$error,
                    }"
                
                  />
                </div>
              </div>

              <div class="row">
                <div class="mb-3 col-sm-5">
                  <div class="row">
                    <div class="d-flex">
                      <label class="form-label">Current Running Rebate</label>
                      <i class="fa fa-info-circle mt-1 mx-2" aria-hidden="true" v-b-tooltip.hover title="When there are no schedule rebate active it will revert back to Default Rebate value above."></i>
                    </div>
                  </div>
                  <div class="row">
                    <span v-if="getCurrentRebateRunning()" class="schedule-active-text">{{ getCurrentRebateRunning() }}</span>
                  </div>
                  <b-input-group>
                    <b-form-input
                    type="text"
                      class="form-control"
                      v-model="topupsItem.topupRebate"
                      placeholder="0%"
                      :disabled="true"
                    ></b-form-input>
                  </b-input-group>
                </div>
              </div>
              <hr style="margin-top: 2rem;">
              <div class="row">
              <div class="col-md-12 mt-3 mb-3">
                <b-row>
                  <label class="form-label fw-bold my-2 col-md-6">Scheduled Rebates</label>
                  <div class="text-end col-md-6 ">
                    <b-button
                      variant="primary" 
                      class="w-sm" 
                      style="width: fit-content;"
                      @click="addDiscount">
                      <i class="uil uil-plus me-1"></i>
                      Add Scheduled Rebate
                    </b-button>

                  </div>
                </b-row>
              </div>
            </div>
            <b-row>
              <b-table 
                ref="rebateTable"
                responsive 
                class=""
                :fields="rebatesTableFields"
                :items="topupsItem.scheduleDetails">
                <template #cell(action)="row">
                  <div class="d-flex">
                    <button 
                      id="show-btn" 
                      type="button" 
                      class="btn btn btn-sm btn-danger btn-secondary me-2"
                      @click="deleteScheduleRebate(row)" :disabled="row.item.isActive && rebateIsNotOver(row)">
                      <i class="bx bx-trash bx-xs bx-fw"></i>
                    </button>
                    <!-- <div class="btn-group me-2 mb-2 mb-sm-0" v-if="rebateIsNotOver(row) && returnRebateStatus(row) != 1">
                      <button 
                        type="button" 
                        class="btn btn-sm btn-secondary"
                        @click="editScheduleRebate(row)" 
                        :disabled="disableEditSchedule(row)">
                        <i class="bx bx-pencil bx-xs bx-fw"></i>
                      </button>
                    </div> -->
                  </div>
                </template>
                <template #cell(rebate)="row">
                  <div>{{ row.item.rebate }}%</div>
                </template>
                <template #cell(startDate)="row">
                  <div>{{ row.item.startDate }}</div>
                </template>
                <template #cell(endDate)="row">
                  <div>{{ row.item.endDate }}</div>
                </template>
                <template #cell(status)="row">
                  <div class="d-flex">
                  
                  
                    
                  <div 
                    class="form-check form-switch form-switch-md float-right mr-3" 
                    dir="ltr"
                    v-if="returnRebateStatus(row) == 0">
                      <label class="form-check-label form-label small">Activate</label>
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :id="'customSwitchsizem' + row.startDate"
                        v-model="row.item.isActive"
                        @click="onClickScheduleRebateStatus(row)"
                        checked
                    />
                  </div>
                  <!-- {{ "Shit: " + returnRebateStatus(row) }} -->
                  <label v-if="returnRebateStatus(row) > 0" class="form-check-label form-label small text-danger" >{{ getRebateStatusLabel(row) }}</label>
                    <!-- <div >
                      <label class="form-check-label form-label small text-danger" >denied</label>
                    </div> -->
                  
                  <!-- <label v-if="rebateIsDenied(row)" class="form-check-label form-label small text-danger" >Schedule has ended</label> -->
                  
                  
                  <i :class="[{ 'fas fa-star star-color mt-2 mx-2': getCurrentRebateRunningByRow(row) }]" v-b-tooltip.hover title="This schedule rebate is on schedule!"></i>
                </div>
                  <!-- <p>{{ data.item.status }}</p> -->
                </template>
              </b-table>
              <div class="row g-0 text-center" v-if="topupsItem.scheduleDetails == null || topupsItem.scheduleDetails.length == 0">
                <span>No data to display.</span>
              </div>
              <div class="row" v-if="skuId > 0">
                <div class="col-md-12 mt-3">
                  <label class="form-label fw-bold my-2">Change Log: &nbsp;</label>
                  <label class="form-label fw-bold my-2">
                    <b-link @click="getRebateLogs()">View</b-link>
                  </label>
                    <div class="mb-1 col-6 text-end">
                    </div>
                </div>
              </div>
            </b-row>
              <div class="text-end mt-4">
                <router-link :to="{ name: 'E-Load Topups', params: {} }" class="tc-white">
                  <b-button variant="light" class="w-sm" type="button" >Cancel</b-button>
                </router-link>
                <b-button :disabled="skuId > 0 ? !eloadTopupsModule.access.update : !eloadTopupsModule.access.create"
                  type="submit"
                  variant="primary"
                  class="w-sm ms-2"

                  >Save</b-button
                >
              </div>
            </form>
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- Add/Edit Rebate Modal -->
    <b-modal
      v-model="showRebateModal"
      size="md"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
      <form class="px-4 py-3" @submit.prevent="submitRebate()">
        <b-row>
          <div class="col-lg-12">
            <label class="form-label fw-bold mb-3"> {{ this.rebateAction == 'add' ? 'Add' : 'Edit' }} Schedule Rebates</label>
            <!-- <div class="form-check form-switch form-switch-md mb-3 float-right mr-3" dir="ltr" v-if="skuId == 0 || rebateAction == 'add'">
              <label 
                class="form-check-label form-label small fw-bold" 
                for="customSwitchsizems"
                style="font-size: 13px;">Activate</label>
              <input
                type="checkbox"
                class="form-check-input"
                id="customSwitchsizems"
                v-model="rebateStatus"
                checked
              />
            </div> -->
            <div class="mb-3">
              <label class="form-label small fw-bold">Scheduled Rebate Amount<span style="color: red">*</span></label>
              <b-input-group append="%">
                <input
                    type="number"
                    class="form-control"
                    v-model="rebateRate"
                    placeholder="Enter Rebate"
                    :class="{
                      'is-invalid': rebateSubmitted && $v.rebateRate.$error,
                    }"
                  />
              </b-input-group>
              <div v-if="rebateSubmitted && !$v.rebateRate.required" 
                class="text-danger small">
                  Schedule Rebate Amount is required
              </div>
            </div>
            <b-row>
              <div class="col-md-6 mb-3">
                <label class="form-label small fw-bold">Start Date<span style="color: red">*</span></label>
                <flat-pickr
                  v-model="rebateStart"
                  placeholder="Select a date"
                  class="form-control"
                  :config="rebateStartDateConfig"
                  :class="{
                    'is-invalid': rebateSubmitted && $v.rebateStart.$error ,
                  }"
                  :disabled="rebateAction == 'edit'"
                ></flat-pickr>
                <div v-if="rebateSubmitted && !$v.rebateStart.required" 
                  class="invalid-feedback">
                    Start Date is required
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label small fw-bold">End Date<span style="color: red">*</span></label>
                <flat-pickr
                v-model="rebateEnd"
                placeholder="Select a date"
                class="form-control"
                :config="rebateEndDateConfig"
                :class="{
                  'is-invalid': rebateSubmitted && $v.rebateEnd.$error,
                }"
                ></flat-pickr>
                <div v-if="rebateSubmitted && !$v.rebateEnd.required" 
                  class="invalid-feedback">
                    End Date is required
                </div>
              </div>
            </b-row>
            
            <div v-if="rebateSubmitted && dateRangeOverlap && (rebateStart != null  && rebateEnd != null)" class="text-danger small">
              <span>Submitted date range overlaps with existing rebate.</span>
            </div>
            <div v-if="rebateSubmitted && dateStartIsOutdated" class="text-danger small">
              <span>Start Date must not behind with the current date.</span>
            </div>
            <div class="text-end mt-4">
              <b-button variant="primary" class="w-sm" type="submit">
                Save
              </b-button>
              <b-button variant="light" class="w-sm ms-2" type="button" @click="closeShowRebateModal">
                Close
              </b-button>
            </div>
          </div>
        </b-row>
      </form>
    </b-modal>
    <!-- END Add/Edit Rebate Modal -->

    <!-- Rebate Logs Modal -->
    <b-modal
      v-model="showRebateLogsModal"
      size="xl"
      centered
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
    >
      <form class="px-4 py-3">
        <div class="row">
          <div class="col-lg-12">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <h5 class="card-title">
                      Rabate Logs
                    </h5>
                  </div>
                </div>

                <!-- Date Range -->
                <div class="col-md-12">
                  <div class="d-flex flex-wrap mt-3 mb-2 ta-right gap-2">
                    <div class="col-sm-3" style="width: fit-content">
                      <b-form-group description="Filter by date">
                        <flat-pickr
                          v-model="logsDateRange"
                          :config="rangeOptions"
                          placeholder="Select a date range"
                          class="form-control"
                          style="width: 250px"
                        ></flat-pickr>
                      </b-form-group>
                    </div>
                    <!-- <div class="col-sm-2">
                      <b-form-group label-for="status" description="Filter by status">
                        <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none"
                          v-model="filter.status"
                          :options="filterStatusOptions"
                        ></b-form-select>
                      </b-form-group>
                    </div> -->
                    <div class="col-sm-1" style="width: fit-content">
                      <b-button variant="primary" type="button" @click="isSearching =true; getRebateLogs()" class="px-2 d-flex align-items-center">
                        <div><i class='bx bx-search bx-fw'></i></div>
                        <div>Search</div>
                      </b-button>
                    </div>
                    <div class="col-sm-1" style="width: fit-content">
                      <b-button variant="primary" @click="onExport" type="button" class="px-2 d-flex align-items-center">
                        <div><i class='uil uil-export me-1'></i></div>
                        <div>Export</div>
                      </b-button>
                    </div>
                  </div>

                </div>
              </div>

              <div class="table-responsive">
                <div class="table align-middle table-nowrap">
                  <b-table
                    :items="rebateLogs"
                    :fields="rebatesLogsFields"
                    responsive="sm"
                    :current-page="logsCurrentPage"
                    :sort-by.sync="logsSortBy"
                    :sort-desc.sync="logsSortDesc"
                    class="table-check"
                    @sort-changed="tableSorting"
                  >
                    <template #cell(skuName)="data">
                      <p class="text-body m-0">
                        {{ data.item.details.skuName }}
                      </p>
                    </template>

                    <template #cell(rebate)="data">
                      <p class="text-body m-0">
                        {{ data.item.details.rebate }}%
                      </p>
                    </template>

                    <template #cell(startDate)="data">
                      <p class="text-body m-0">
                        {{ data.item.details.startDate }}
                      </p>
                    </template>

                    <template #cell(endDate)="data">
                      <p class="text-body m-0">
                        {{ data.item.details.endDate }}
                      </p>
                    </template>
                    <template #cell(isActive)="data">
                      <p class="text-body m-0">
                        {{ data.item.details.isActive ? 'Yes' : 'No' }}
                      </p>
                    </template>
                    
                    <template #cell(dateCreated)="data">
                      <p class="text-body m-0">{{ data.item.created_at | formatDate }}</p>
                    </template>

                    <template #cell(createdBy)="data">
                      <p class="text-body m-0">{{ data.item.actor }}</p>
                    </template>
                  </b-table>
                </div>
              </div>
              <!-- end table responsive -->

              <div class="row g-0 text-center" v-if="scheduleRebateLogsTotal == 0">
                <span>No data to display.</span>
              </div>
              <div class="row g-0 text-center text-sm-start" v-if="scheduleRebateLogsTotal != 0 && scheduleRebateLogsTotal > 10">
                <!-- end col -->
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col">
                      <div class="form-group row pull-left">
                        <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                        <div class="col-sm-6">
                          <b-form-group label-for="display-record">
                            <b-form-select class="form-select shadow-none w-fit"
                              id="display-record"
                              v-model="logsPerPage"
                              :options="logsPageOptions"
                              @change="getRebateLogs()"
                            ></b-form-select>
                          </b-form-group>
                        </div>
                      </div>
                      <div
                        class="dataTables_paginate paging_simple_numbers float-end" 
                        v-if="scheduleRebateLogsTotal > logsPerPage"
                      >
                        <!-- pagination -->
                        <b-pagination
                          class="pagination-rounded"
                          v-model="logsCurrentPage"
                          :total-rows="scheduleRebateLogsTotal"
                          :per-page="logsPerPage"
                          @input="getRebateLogs()"
                        ></b-pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3 px-1">
          <b-button
            variant="light"
            class="w-sm"
            @click="closeLogsModal()"
            >Close</b-button
          >
        </div>
      </form>
    </b-modal>
    <!-- end row -->
  </div>
</template>

<style scoped>
  .schedule-active-text {
    color: #E72F92;
    font-size: 11px;
  }

  .star-color {
    color: #E72F92;
  }
</style>